export default __webpack_public_path__ + "static/arcade-a809b3c375ba76b453970bf7074b1702.png";